module.exports = __webpack_public_path__ + "static/img/sec2-cont01-img04@mt.054b24f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/lgchem-history/sec2-cont01-img04@mt.png
// module id = 0kbF
// module chunks = 0